import React from 'react';
import {useForm} from "react-hook-form";
import {NavLink, useNavigate} from "react-router-dom";
import {participant} from "../../../models/participant";
import {Require} from "../Require";
import {ApiError, ApiService} from "../../../service/ApiService";
import {scrollTo} from "../../../service/ToolsService";
import {race} from "../../../models/race";

type FormDataType = {
  name: string;
  rank?: number;
}

type ParticipantFormProps = {
  participant?: participant,
  race: race,
}

export const ParticipantForm = ({participant, race}: ParticipantFormProps) => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setError,
    formState: {errors}
  } = useForm<FormDataType>({
    defaultValues: {
      name: participant?.name,
      rank: participant?.rank,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const d = {
      raceId: race.raceId,
      name: data.name,
      rank: data.rank || undefined,
    };

    try {
      if (participant) {
        await ApiService.patch(`/participant/${participant.participantId}`, {param: () => d})
      } else {
        await ApiService.post('/participant', {param: () => d})
      }

      navigate(`/admin/race/participant/${race.raceId}`)
      scrollTo();
    } catch (e: any) {
      const error: ApiError = e as ApiError;

      error.errors?.forEach((e: {
        field: string,
        message: string
      }) => {
        return setError(e.field as "name" | "rank", {
          type: "manual",
          message: e.message
        });
      });
    }
  }

  return (
    <>
      <form className="p-3" method="post" onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex">
          <div className="col max-w600px pe-4">
            <div className="mb-3">
              <label className="form-label" htmlFor="form-label">Nom <Require/></label>
              <input id="form-label" type="text" className="form-control" placeholder="~" {...register('name', {
                required: 'Le nom est requis',
                validate: {
                  maxLength: (value) =>
                    (value ?? '').length <= 255 || 'Le nom ne doit pas dépasser 255 caractères',
                },
              })} />
              {errors.name && <p className="text-danger">{errors.name.message}</p>}
            </div>
            <div className="col max-w200px ms-1">
              <label className="form-label" htmlFor="form-rank">Place</label>
              <input id="form-rank" type="number" className="form-control" placeholder="~" {...register('rank', {
                setValueAs: (value) => (value === "" ? undefined : Number(value)),
                validate: {
                  valide: (value) =>
                    value === undefined || Number.isInteger(value) || "La place doit être un entier",
                },
              })} />
              {errors.rank && <p className="text-danger">{errors.rank.message}</p>}
            </div>
          </div>
        </div>

        <div className="mt-3">
          <button className="btn btn-sm btn-success me-1" type="submit">Enregistrer</button>
          <NavLink to={`/admin/race/participant/${race.raceId}`} onClick={scrollTo} className="btn btn-sm btn-info">Retour aux participants</NavLink>
        </div>
      </form>
    </>
  );
}
